import {
	FCM_SIGNATURE_GROWTH_PSF_FB_SHARE_HEADLINES,
	FCM_SIGNATURE_GROWTH_PSF_WHATSAPP_SHARE_MESSAGE,
} from '@change-corgi/fcm/configs';

import { createExperimentFcmConfig } from 'src/app/shared/hooks/experiment';

export const FCM_EXPERIMENT_SHARE_COPY_HEADLINES_WHATSAPP = createExperimentFcmConfig({
	experimentName: ({ fcm: { config } }) => config.experimentName,
	fcmConfigs: {
		config: FCM_SIGNATURE_GROWTH_PSF_WHATSAPP_SHARE_MESSAGE,
	},
	isEnabled: ({ fcm: { config } }) => {
		return config.isEnabled;
	},
});

export const FCM_EXPERIMENT_SIGNATURE_GROWTH_PSF_FB_SHARE_HEADLINES = createExperimentFcmConfig({
	experimentName: ({ fcm: { config } }) => config.experimentName,
	fcmConfigs: {
		config: FCM_SIGNATURE_GROWTH_PSF_FB_SHARE_HEADLINES,
	},
	isEnabled: ({ fcm: { config } }) => {
		return config.isEnabled;
	},
});
